import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { Star, Quote, CircleCheck, MapPin, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
const testimonials = [{
  id: 1,
  name: "Marcus",
  role: "UofT Student",
  university: "University of Toronto",
  country: "The Annex",
  flagImg: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1611703/img/toronto_skyline_icon.png",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1611703/img/user_marcus.png",
  quote: "HalfOrder makes splitting those 2-for-1 deals at the Annex so easy. I'm eating better food for half the price while meeting people in my building.",
  rating: 5,
  verified: true,
  savings: "$140"
}, {
  id: 2,
  name: "Sarah",
  role: "Marketing Grad",
  university: "TMU",
  country: "Liberty Village",
  flagImg: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1611703/img/toronto_skyline_icon.png",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1611703/img/user_sarah.png",
  quote: "Living in Toronto is expensive, but my monthly food bill dropped by 40% since I started sharing family-sized orders with my neighbors.",
  rating: 5,
  verified: true,
  savings: "$85"
}, {
  id: 3,
  name: "Liam",
  role: "Software Dev",
  university: "George Brown",
  country: "Distillery District",
  flagImg: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1611703/img/toronto_skyline_icon.png",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1611703/img/user_liam.png",
  quote: "The real-time matching is insane. I post a craving for Thai food, and within minutes I've found someone nearby to split a massive order with.",
  rating: 5,
  verified: true,
  savings: "$210"
}, {
  id: 4,
  name: "Chloe",
  role: "Design Student",
  university: "OCAD U",
  country: "Kensington Market",
  flagImg: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1611703/img/toronto_skyline_icon.png",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1611703/img/user_chloe.png",
  quote: "It's not just about the money. I've met three of my best friends through shared orders. It's the most social way to get takeout in the city.",
  rating: 4,
  verified: true,
  savings: "$120"
}];
export default function VoicesOfSuccess() {
  return <section data-section-id="51086" id="words-from-the-campus" className="dark bg-background text-foreground relative overflow-hidden py-24 sm:py-32">
      {}
      <div className="bg-primary/10 absolute -top-24 -right-24 h-96 w-96 rounded-full blur-3xl" />
      <div className="bg-primary/5 absolute -bottom-24 -left-24 h-96 w-96 rounded-full blur-3xl" />

      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-16 text-center">
          <Badge variant="outline" className="mb-4 border-primary/20 bg-primary/10 text-primary uppercase tracking-widest">
            The Social Split
          </Badge>
          <h2 className="text-foreground mb-4 text-4xl font-black tracking-tighter sm:text-5xl uppercase">
            Words from the <span className="text-primary">Campus</span>
          </h2>
          <p className="text-muted-foreground mx-auto max-w-2xl text-lg">
            Join thousands of Toronto students and young professionals splitting the bill and doubling the flavor with HalfOrder.
          </p>
        </div>

        <div className="mx-auto max-w-5xl">
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full">
            <CarouselContent className="-ml-4">
              {testimonials.map((testimonial, i) => <CarouselItem key={testimonial.id} className="pl-4 md:basis-full lg:basis-full" data-index={i}>
                  <div className="p-1">
                    <Card className="bg-card/40 border-white/10 overflow-hidden border shadow-2xl backdrop-blur-xl">
                      <CardContent className="p-0">
                        <div className="flex flex-col md:flex-row">
                          {}
                          <div className="relative h-64 w-full md:h-auto md:w-2/5 lg:w-1/3">
                            <div className="absolute inset-0 bg-gradient-to-t from-background/80 to-transparent md:hidden" />
                            <img src={testimonial.image} alt={testimonial.name} className="h-full w-full object-cover grayscale hover:grayscale-0 transition-all duration-500" />
                            <div className="absolute bottom-4 left-4 md:hidden">
                              <div className="text-white font-black text-xl uppercase tracking-tighter">{testimonial.name}</div>
                              <div className="text-primary text-sm font-bold">{testimonial.university}</div>
                            </div>
                          </div>

                          {}
                          <div className="flex flex-1 flex-col justify-center p-6 md:p-10 lg:p-12">
                            <div className="mb-6 flex items-center justify-between">
                              <div className="flex items-center gap-2">
                                <div className="bg-primary/20 flex size-8 items-center justify-center overflow-hidden rounded-full border border-primary/50 shadow-sm">
                                  <MapPin className="size-4 text-primary" />
                                </div>
                                <span className="text-muted-foreground text-sm font-bold uppercase tracking-wide">
                                  {testimonial.country}
                                </span>
                              </div>
                              {testimonial.verified && <Badge variant="secondary" className="bg-primary/20 text-primary border border-primary/30 hover:bg-primary/30">
                                  <CircleCheck className="mr-1 size-3" />
                                  Saved {testimonial.savings}
                                </Badge>}
                            </div>

                            <div className="mb-6">
                              <div className="mb-4 flex gap-1">
                                {[...Array(5)].map((_, i) => <Star key={i} className={`size-4 ${i < testimonial.rating ? "fill-primary text-primary" : "fill-muted text-muted"}`} />)}
                              </div>
                              <Quote className="text-primary/10 mb-4 size-12 rotate-180" />
                              <blockquote className="text-foreground font-serif text-2xl font-medium leading-tight italic md:text-3xl">
                                "{testimonial.quote}"
                              </blockquote>
                            </div>

                            <div className="mt-auto flex items-center gap-4 border-t border-white/5 pt-6">
                              <div className="hidden md:block">
                                <SafeHydrate><Avatar className="size-14 border-2 border-primary shadow-lg shadow-primary/20">
                                  <AvatarImage src={testimonial.image} alt={testimonial.name} />
                                  <AvatarFallback className="bg-primary text-primary-foreground font-bold">{testimonial.name.charAt(0)}</AvatarFallback>
                                </Avatar></SafeHydrate>
                              </div>
                              <div>
                                <div className="text-foreground font-black text-xl uppercase tracking-tighter">
                                  {testimonial.name}
                                </div>
                                <div className="text-muted-foreground font-mono text-xs uppercase tracking-widest">
                                  {testimonial.role}, {testimonial.university}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            <div className="hidden md:block">
              <CarouselPrevious className="-left-12 border-primary/20 bg-background/80 text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300" />
              <CarouselNext className="-right-12 border-primary/20 bg-background/80 text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300" />
            </div>
            
            {}
            <div className="mt-8 flex justify-center gap-4 md:hidden">
               <CarouselPrevious className="static translate-y-0 border-primary/20 bg-background/80 text-primary hover:bg-primary hover:text-primary-foreground" />
               <CarouselNext className="static translate-y-0 border-primary/20 bg-background/80 text-primary hover:bg-primary hover:text-primary-foreground" />
            </div>
          </Carousel>

          <div className="mt-12 text-center">
            <Button asChild size="lg" className="rounded-sm px-10 shadow-xl shadow-primary/20 bg-primary hover:bg-primary/90 text-primary-foreground font-black uppercase tracking-tighter transition-all hover:scale-105">
              <Link to="/FeaturesPage">
                Explore The App <ArrowRight className="ml-2 size-4" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}